import { mixins } from 'consumer-components';
import * as deploymentConfig from 'login-utils/deploymentConfig';

export const loginBackgroundColor = deploymentConfig.getOrganizationColors().loginBackground;
export const loginBackgroundDynamicColor = mixins.dynamicColor(loginBackgroundColor);
